const ACCEPTED = ['image/png', 'image/jpeg', 'image/webp'];
export const SCREENSHOT_ACCEPT = ACCEPTED.join(',');
const MAX_INPUT_BYTES = 15 * 1024 * 1024;
const MAX_EDGE = 1600;

function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Could not read the image'));
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Could not open the image'));
    img.src = src;
  });
}

/**
 * Payment screenshots from phones can be several MB; downscale to JPEG so the
 * upload stays well under the server's 5 MB limit.
 */
export async function screenshotToDataUrl(file) {
  if (!file) throw new Error('No file selected');
  if (!ACCEPTED.includes(file.type)) throw new Error('Choose a PNG, JPG or WEBP image');
  if (file.size > MAX_INPUT_BYTES) throw new Error('Image is too large (max 15 MB)');
  const original = await readAsDataUrl(file);
  try {
    const img = await loadImage(original);
    const scale = Math.min(1, MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const compressed = canvas.toDataURL('image/jpeg', 0.85);
    return compressed.length < original.length ? compressed : original;
  } catch {
    return original;
  }
}
